import colors from "./colors";
import shades from "./shades";

export default {
    owned: true,
    light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        contrast: '#000000',

        ...shades,
        ...colors
    },
    dark: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        contrast: '#FFFFFF',

        ...shades,
        ...colors
    }
}
